'use strict';

$(document).ready(function() {
  // layout
  // main padding-top
  $(function() {
    var paddingTopMain = function() {
      var heightHeader = $(".melon-container-fixed .melon-header").height();
      var addPaddingTarget = $(".melon-container-fixed .melon-main");
      $(addPaddingTarget).css("padding-top", heightHeader + "px");
    }
    paddingTopMain();
    $(window).resize(function(){
      paddingTopMain();
    });
  });

  // # notice 공통
  $(function() {
    $('.content-notice .btn-fold').on('click', function () {
      const btn = $(this);
      const notice = $('.content-notice');
  
      const isExpanded = notice.hasClass('on');
  
      if (isExpanded) {
        // 이미 펼쳐져 있으니 접기
        notice.removeClass('on');
        btn.attr("aria-expanded", "false");
      } else {
        // 접혀 있으니 펼치기
        notice.addClass('on');
        btn.attr("aria-expanded", "true");
      }
    });
  });

      // notice
      // $(function () {
      //   $('.content-notice .btn-fold').on('click', function () {
      //     if ($('.content-notice').hasClass('on') === true) {
      //       $('.content-notice').toggleClass('on');
      //       $('.content-notice .notice-head .screen-out').text('열기');
      //     } else {
      //       $('.content-notice').toggleClass('on');
      //       $('.content-notice .notice-head .screen-out').text('닫기');
      //     }
      //   });
      // });
});

